import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbButtonModule, MdbCollapseModule, MdbModalModule, MdbTabsModule } from 'src/lib/mdb5-adapted/public-api';
import { LMSSharedUiModule } from '@lmsSharedUI';
import { RatesAndFeesRoutingModule } from "./rates-and-fees-routing.module";
import { RemoveLoanTypeDialogComponent } from "./remove-loan-type/remove-loan-type.component";
import { AddLoanTypeComponent } from "./add-loan-type/add-loan-type.component";
import { RatesAndFeesComponent } from "./rates-and-fees.component";

@NgModule({
    imports: [
        CommonModule,
        RatesAndFeesRoutingModule,
        MdbTabsModule,
        MdbButtonModule,
        MdbCollapseModule,
        LMSSharedUiModule,
        AddLoanTypeComponent,
        RemoveLoanTypeDialogComponent,
        RatesAndFeesComponent
    ]
})
export class RatesAndFeesModule { }
